import { createAsyncThunk } from '@reduxjs/toolkit';
import { SearchResponse, encodeSearchObject } from '@sparted/shared-library';

import { fetchFactory } from 'Libs/http/utils';
import { store } from 'Libs/redux/store';

import { EntityPlayer } from './entity-players.type';

type EntityParams = {
  entityId: number;
  entityType: 'course' | 'activity';
};

type SearchParams = {
  name: string;
  offset: number;
};

type SearchEntityPlayerParams = {
  entity: EntityParams;
  searchParams: SearchParams;
};

const LIMIT = 20;

export const SEARCH_ENTITY_PLAYERS = 'entityPlayers/search';
export const searchEntityPlayer = createAsyncThunk(
  SEARCH_ENTITY_PLAYERS,
  async ({ entity, searchParams }: SearchEntityPlayerParams) => {
    const { fetchFn } = fetchFactory<SearchResponse<EntityPlayer>>({
      method: 'GET',
      route: `/api/audiences/groups/players/${entity.entityType}/${entity.entityId}?${encodeSearchObject({
        limit: LIMIT,
        offset: searchParams.offset,
        query: {
          name: searchParams.name,
        },
      })}`,
    });

    return fetchFn();
  },
);

export const SEARCH_NEXT_ENTITY_PLAYERS = 'entityPlayers/searchNext';
export const searchNextEntityPlayer = createAsyncThunk(
  SEARCH_NEXT_ENTITY_PLAYERS,
  async ({ entityId }: { entityId: number }) => {
    const state = store.getState();
    const next = state.entities.entityPlayers.entities[entityId]?.metadata.next;

    if (!next) {
      return;
    }

    const { fetchFn } = fetchFactory<SearchResponse<EntityPlayer>>({
      method: 'GET',
      route: next,
    });

    return fetchFn();
  },
);
